class SmoothScroll {

    /**
     * @since 4.0.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector     = 'a.smooth[href*="#"]:not([href="#"])';
        this.selectorItem = '.menu-item.smooth a[href*="#"]:not([href="#"])';

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.0.0
     * @returns object The initialized map
     */
    init() {

        // Listen for the smooth scroll activator
        $([this.selector, this.selectorItem].join(', ')).click(function () {

            // Declare and initialize
            let button   = $(this);
            let path     = location.pathname.replace(/^\//, '');
            let anchor   = this.pathname.replace(/^\//, '');
            let isOnPage = path === anchor;
            let isLocal  = location.hostname === this.hostname;
            let isTop    = '#top' === this.hash;

            // Only continue for anchors to on-page elements
            if (!isLocal || !isOnPage) return;

            // Setup identifiers
            let target = isTop ? $('html') : $(this.hash);

            // If the target does not exist, bail out
            if (!target.length && !isTop) return;

            // Figure out what value to use for positioning
            let customOffset = $(this).data('stepnav-offset') || 0;
            let position = target.offset().top - customOffset;
            let offset   = isTop ? 0 : 100;
            let top      = Math.abs(position - offset);

            // Add an active class
            button.addClass('active').closest('.smooth')
                .siblings().find('a').removeClass('active');

            // Scroll into view
            $('html, body').animate({scrollTop: top}, 1000);

            // Prevent leaks
            return false;

        });
    }
}

export default SmoothScroll;